import React, { useContext, useEffect, useState } from "react";
import { AppContext } from "../State/Context";
import { ActionType } from "../State/State";
import { BasicPopup } from "./BasicPopup";
import { askAPI, RequestMethod } from "../api/api";

export const ReportPopup: React.FC = () => {
  const { state, dispatch } = useContext(AppContext);
  const [x, setX] = useState<string>("");
  const [y, setY] = useState<string>("");

  useEffect(() => {
    if (state.selectedHexCoord) {
      setX(String(state.selectedHexCoord.x));
      setY(String(state.selectedHexCoord.y));
    }
  }, [state.selectedHexCoord]);

  const close = () => {
    dispatch({ type: ActionType.TOGGLE_REPORT_POPUP });
  };

  const canSubmit = () => {
    const xi = Number(x);
    const yi = Number(y);
    return Number.isFinite(xi) && Number.isFinite(yi) && Number.isInteger(xi) && Number.isInteger(yi);
  };

  const onSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!canSubmit()) return;
    const res = await askAPI<{ message: string }>("/api/report", RequestMethod.POST, { x: Number(x), y: Number(y) });
    if (res) close();
  };

  if (!state.isReportPopupOpen) return null;

  return (
    <BasicPopup onClose={close}>
      <div className="font-bold text-lg mb-6">Report Content</div>
      <div>Send a report about the selected hex image if it violates the rules.</div>
      <form onSubmit={onSubmit} className="mb-6 mt-6">
        <input
          type="number"
          value={x}
          onChange={(e) => setX(e.target.value)}
          placeholder="X"
          className="px-2 p-1 mr-2 outline-none w-12"
        />
        <input
          type="number"
          value={y}
          onChange={(e) => setY(e.target.value)}
          placeholder="Y"
          className="px-2 p-1 mr-2 outline-none w-12"
        />
        <button type="submit" disabled={!canSubmit()} className="button mb-1 px-2 py-1 ml-1 text-xs disabled:opacity-40">
          Report
        </button>
      </form>
    </BasicPopup>
  );
};


